import { useEffect, useMemo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getSelectedTeam } from '../../../store/commissions/selectors';
import { TEditTeam } from '../../../types';
import { usePermissions } from '../../../hooks/useCommon';
import { useTeamPermissions } from '../../team/hooks';
import { getDiffBetweenNestedObj } from '../../../utils/helpers';
import { INITIAL_TEAM_FORM } from '../data/commissions';

export function useEditTeam() {
  const selectedTeam = useAppSelector(getSelectedTeam);
  const [mode, setMode] = useState('create');
  const { teamPermissions } = useTeamPermissions();
  const { permissions } = usePermissions();
  const [formInputs, setFormInputs] = useState(INITIAL_TEAM_FORM);
  const [prevFormInputs, setPrevFormInputs] = useState(INITIAL_TEAM_FORM);

  useEffect(() => {
    if (selectedTeam?.id) {
      setMode(teamPermissions.isAllowManage && !permissions.isEmployee ? 'edit' : 'view');

      const teamData = {
        teamName: selectedTeam.teamName,
        commissionModel: selectedTeam.commissionModel,
        members: selectedTeam.members || [],
        locationTag: selectedTeam.locationTag,
        commissionPlan: selectedTeam?.commissionPlan || null,
      } as unknown as TEditTeam;

      setFormInputs(teamData);
      setPrevFormInputs(teamData);
    } else {
      setMode('create');
      setFormInputs(INITIAL_TEAM_FORM);
    }
  }, [selectedTeam]);

  const isEdited = useMemo(() => {
    const diff = getDiffBetweenNestedObj(formInputs, prevFormInputs);

    return !isEmpty(diff);
  }, [formInputs, prevFormInputs]);

  return {
    mode,
    isEdited,
    formInputs,
    setFormInputs,
  };
}
